// since you never know what fields will be missing

export function getValuesOfEnum(enumType) {
  return Object.keys(enumType).filter(function (key) {
    return Number.isNaN(Number(key));
  }).map(function (key) {
    return enumType[key];
  });
}